import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import LoginForm from './login/loginForm';
import PatientLoginForm from './patient-app/login/loginForm';
import PatientHome from './patient-app/home/home';
import Layout from './components/layout/layout';
import Agenda from './agenda/agendaRouter';
import AgendaRouterPage from './agenda-router/agendaRouterPage';
import PatientList from './patient/list/patient-list';
import Home from './home/homeRouter';
import Appointment from './appointment/appointmentRouter';
import PatientForm from './patient/form/patient-form';
import './App.css';
import ExpiredSession from './expired-session/expiredSession';
import TreatmentToPrint from './patient/form/treatments/treatmentToPrint';
import TreatmentEvolutionToPrint from './patient/form/treatments/treatmentEvolutionToPrint';
import PrescriptionToPrint from './patient/form/prescriptions/prescriptionToPrint';
import PrescriptionToPrintWithTemplate from './patient/form/prescriptions/prescriptionToPrintWithTemplate';
import PrescriptionToControlledMedicinesToPrint from './patient/form/prescriptions/prescriptionToControlledMedicinesToPrint';
import AttestedToPrint from './patient/form/attested/attestedToPrint';
import ChangePassword from './change-password/changePassword';
import RegisterPage from './register/registerPage';
import PrintSettings from './print-settings/printSettings';
import TermsRouter from './configuration/terms/termsRouter';
import NotificationsList from './notifications/notificationsList';
import InterestedClientPage from './trial/InterestedClientPage';
import ThankYouPage from './trial/ThankYouPage';
import IncomesRouter from './financial/incomes/incomesRouter';
import ExpensesRouter from './financial/expenses/expensesRouter';
import FinancialDashboardRouter from './financial/dashboard/FinancialDashboardRouter';
import AppointmentListToConfirm from './appointment/toConfirm/appointmentListToConfirm';
import AppointmentConfirmation from './appointment/public/appointmentConfirmation';
import GeneralSettings from './settings/general/generalSettings';
import AccessPage from './settings/access/accessPage';
import MessageSentPage from './settings/messagesent/messageSentPage';
import ClinicSettings from './settings/clinic/clinicSettings';
import UsersAndAccess from './configuration/usersAndAccess/usersAndAccess';
import ClinicNotificationsRouter from './clinic-notifications/clinicNotificationsRouter';
import BenefitsPage from './benefits/BenefitsPage';
import NpsList from './admin/nps/npsList';
import Dashboard from './dashboard/Dashboard';
import DashboardAppointmentList from './dashboard/DashboardAppointmentList';
import MarketingHome from './marketing/MarketingHome';
import KanbanTaskRouter from './taskmanager/kanbanTaskRouter';
import ClinicalProductionRouter from './reports/clinicalProduction/ClinicalProductionRouter';
import RoleGuard from './components/roleGuard';
import SentMessagesRouter from './sentMessages/SentMessagesRouter';
import LabOrdersRouter from './laboratory/labOrdersRouter';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginForm />} />

      <Route path="/patient-app/login" element={<PatientLoginForm />} />

      <Route path="/patient-app/home" element={<PatientHome />} />

      <Route path="/" element={<Navigate to="/login" replace />} />

      <Route
        path="/home"
        element={
          <Layout>
            <Home />
          </Layout>
        }
      />

      <Route
        path="/dashboard"
        element={
          <Layout>
            <Dashboard />
          </Layout>
        }
      />

      <Route
        path="/dashboard/canceled-appointments"
        element={
          <Layout>
            <DashboardAppointmentList
              title="Consultas canceladas"
              endpoint="/dashboard/appointments/canceled"
              emptyMessage="Nenhuma consulta cancelada no período."
              showCancellationReason
            />
          </Layout>
        }
      />

      <Route
        path="/dashboard/no-show-appointments"
        element={
          <Layout>
            <DashboardAppointmentList
              title="Faltas"
              endpoint="/dashboard/appointments/no-show"
              emptyMessage="Nenhuma falta registrada no período."
            />
          </Layout>
        }
      />

      <Route
        path="/agenda"
        element={
          <Layout>
            <Agenda />
          </Layout>
        }
      />

      <Route
        path="/agenda-router"
        element={
          <Layout>
            <AgendaRouterPage />
          </Layout>
        }
      />

      <Route
        path="/appointments"
        element={
          <Layout>
            <AppointmentListToConfirm />
          </Layout>
        }
      />

      <Route
        path="/patient-list"
        element={
          <Layout>
            <PatientList />
          </Layout>
        }
      />

      <Route
        path="/patient-form/:patientId?"
        element={
          <Layout>
            <PatientForm />
          </Layout>
        }
      />

      <Route path="/expired-session" element={<ExpiredSession />} />

      <Route
        path="/appointment/:appointmentId?"
        element={
          <Layout>
            <Appointment />
          </Layout>
        }
      />

      <Route
        path="/cadastros"
        element={
          <Layout>
            <RegisterPage />
          </Layout>
        }
      />

      <Route
        path="/financial/incomes"
        element={
          <Layout>
            <RoleGuard allowedRoles={['FINANCIAL', 'CLINIC_ADMIN']}>
              <IncomesRouter />
            </RoleGuard>
          </Layout>
        }
      />

      <Route
        path="/financial/expenses"
        element={
          <Layout>
            <RoleGuard allowedRoles={['FINANCIAL', 'CLINIC_ADMIN']}>
              <ExpensesRouter />
            </RoleGuard>
          </Layout>
        }
      />

      <Route
        path="/financial-dashboard"
        element={
          <Layout>
            <RoleGuard allowedRoles={['FINANCIAL', 'CLINIC_ADMIN']}>
              <FinancialDashboardRouter />
            </RoleGuard>
          </Layout>
        }
      />

      <Route
        path="/print-settings?"
        element={
          <Layout>
            <PrintSettings />
          </Layout>
        }
      />

      <Route path="/treatment-to-print/:treatmentId" element={<TreatmentToPrint />} />

      <Route
        path="/treatment-evolution-to-print/:treatmentId"
        element={<TreatmentEvolutionToPrint />}
      />

      <Route
        path="/prescription-to-print/:patientId/:prescriptionId"
        element={<PrescriptionToPrint />}
      />

      <Route
        path="/prescription-to-print-template/:patientId/:prescriptionId"
        element={<PrescriptionToPrintWithTemplate />}
      />

      <Route
        path="/prescription-controlled-medicines-to-print/:patientId/:prescriptionId"
        element={<PrescriptionToControlledMedicinesToPrint />}
      />

      <Route path="/attested-to-print/:patientId/:attestedId" element={<AttestedToPrint />} />

      <Route
        path="/change-password"
        element={
          <Layout>
            <ChangePassword />
          </Layout>
        }
      />

      <Route
        path="/terms"
        element={
          <Layout>
            <TermsRouter />
          </Layout>
        }
      />

      <Route
        path="/settings/general"
        element={
          <Layout>
            <GeneralSettings />
          </Layout>
        }
      />

      <Route
        path="/settings/clinic"
        element={
          <Layout>
            <ClinicSettings />
          </Layout>
        }
      />

      <Route
        path="/configuration/users"
        element={
          <Layout>
            <UsersAndAccess />
          </Layout>
        }
      />

      <Route
        path="/settings/notifications"
        element={
          <Layout>
            <NotificationsList />
          </Layout>
        }
      />

      <Route
        path="/settings/access"
        element={
          <Layout>
            <AccessPage />
          </Layout>
        }
      />

      <Route
        path="/clinic-notifications"
        element={
          <Layout>
            <ClinicNotificationsRouter />
          </Layout>
        }
      />

      <Route
        path="/settings/messagesent"
        element={
          <Layout>
            <MessageSentPage />
          </Layout>
        }
      />

      <Route
        path="/sent-messages"
        element={
          <Layout>
            <RoleGuard allowedRoles={['CLINIC_ADMIN']}>
              <SentMessagesRouter />
            </RoleGuard>
          </Layout>
        }
      />

      <Route
        path="/benefits"
        element={
          <Layout>
            <BenefitsPage />
          </Layout>
        }
      />

      <Route
        path="/nps"
        element={
          <Layout>
            <NpsList />
          </Layout>
        }
      />

      <Route
        path="/marketing"
        element={
          <Layout>
            <MarketingHome />
          </Layout>
        }
      />

      <Route
        path="/tasks"
        element={
          <Layout>
            <KanbanTaskRouter />
          </Layout>
        }
      />

      <Route
        path="/laboratory"
        element={
          <Layout>
            <LabOrdersRouter />
          </Layout>
        }
      />

      <Route
        path="/reports/clinical-production"
        element={
          <Layout>
            <RoleGuard allowedRoles={['CLINIC_ADMIN']}>
              <ClinicalProductionRouter />
            </RoleGuard>
          </Layout>
        }
      />

      <Route path="/register" element={<InterestedClientPage />} />
      <Route path="/thank-you" element={<ThankYouPage />} />
      <Route path="/public/confirm-appointment" element={<AppointmentConfirmation />} />
    </Routes>
  );
}
